// extracted by mini-css-extract-plugin
export default {"horizontal":"FormItem_horizontal__Vw+Kj"};